const Welcome = props => {
  return (
    <div>
      Welcome
    </div>
  );
}

export default Welcome;